import React from "react";
import { cn } from "@/storyblok/utils/cn";
import Title from "@/library/sections/texts/Title";
import StoryBlokLink from "@/storyblok/utils/links/StoryBlokLink";

export default function TextColumn({
  title,
  text,
  buttons,
  textColor,
  titleColor,
}) {
  const textClasses = cn("overflow-y-auto max-h-20 mb-2", {
    "text-textPrimary": textColor === "textPrimary",
    "text-textSecondary": textColor === "textSecondary",
    "text-textBlack": textColor === "textBlack",
    "text-textLight": textColor === "textLight",
    "text-textWhite": textColor === "textWhite",
    "text-textGrey": textColor === "textGrey",
    "text-textOrange": textColor === "textOrange",
  });


  return (
    <div className="flex flex-col items-start justify-between md:w-56 h-full">
      <Title title={title} titleColor={titleColor} titleAs={"h2"} />
      {text && <p className={`text-base ${textClasses}`}>{text}</p>}
      {buttons.length > 0 && (
        <div className="flex flex-wrap gap-4 mt-6">
          {buttons.map((button) => (
            <StoryBlokLink
              key={button._uid}
              buttonText={button.buttonText}
              buttonType={button.buttonType || "orange"}
              link={button.buttonLink}
            />
          ))}
        </div>
      )}
    </div>
  );
}
